import styled from 'styled-components';

// The category listing reuses the SearchApp layout shell (SearchApp.styled
// Container/Layout, FilterPanel.styled sidebar, ResultsPanel.styled grid,
// SearchToolbar.styled toolbar) for visual parity with the search surface.
// Only the no-results state is category-specific.

export const NoResults = styled.section`
  max-width: var(--max-width);
  margin: 0 auto;
  padding: var(--spacing-base);
  text-align: center;
`;

export const NoResultsImage = styled.img`
  max-width: 12rem;
  height: auto;
  margin: 0 auto var(--spacing-base);
  display: block;
`;

export const ShowMoreLink = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 10rem;
  min-height: 2.75rem;
  padding: 0.625rem 1.25rem;
  border: 1px solid var(--grey-300);
  border-radius: var(--radius-large, 8px);
  background: var(--white);
  color: var(--grey-700);
  font-family: 'Inter', sans-serif;
  font-size: var(--font-size-text-sm, 0.875rem);
  font-weight: var(--font-weight-semibold, 600);
  line-height: 1.25rem;
  text-decoration: none;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;

  &:hover {
    background: var(--grey-50);
    border-color: var(--grey-400);
  }

  &:focus-visible {
    outline: 0;
    box-shadow: var(--shadow-focus);
  }

  &[aria-busy='true'] {
    pointer-events: none;
    opacity: 0.7;
  }
`;
